export const SEARCH_VALUES = "SEARCH_VALUES";
export const SEARCH_BY_STORE = 'SEARCH_BY_STORE'
export const SEARCH_BY_CATEGORY = 'SEARCH_BY_CATEGORY'
export const SEARCH_PRODUCT = 'SEARCH_PRODUCT'
export const SEARCH_BY_NAME = 'SEARCH_BY_NAME'